import { TFunction } from 'i18next';

import { Finances } from '@typings/finances';

export const useDistrictFinanceMenu = (
  t: TFunction,
  districtId: string,
  isLeader?: Boolean
) => {
  const managerDistrictFinanceMenu = [
    {
      label: t('district-invoice.view-invoices', 'View invoices'),
      path: `/district/${districtId}/view-invoices`,
      description: t(
        'district-invoice.view-the-most-recent-invoices',
        'View the most recent invoices for each of your clubs.'
      ),
    },
    {
      label: t(
        'district-invoice.view-club-balance-report',
        'View club balance report'
      ),
      path: `/district/${districtId}/view-club-balance-report`,
      description: '',
    },
    {
      label: t(
        'district-invoice.about-the-club-invoice',
        'About the club invoice'
      ),
      path: `/manage/club-district-administration/club-invoice`,
      description: '',
    },
  ];

  const viewerDistrictFinanceMenu = [
    {
      label: t(
        'district-invoice.about-the-club-invoice',
        'About the club invoice'
      ),
      path: `/manage/club-district-administration/club-invoice`,
      description: '',
    },
  ];

  const data: Finances.MenuResponse = isLeader
    ? managerDistrictFinanceMenu
    : viewerDistrictFinanceMenu;

  return {
    data,
  };
};
